 <template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Enheter</div>
                <br>

                <v-btn color="success" sx2 @click="openNewUnit">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Ny enhet
                </v-btn>

                <v-row>
                    <v-col>
                        <v-data-table :items="units" :headers="headers" :loading="unitsLoading" hide-default-footer :items-per-page="-1" :mobile-breakpoint="0">
                            <template v-slot:item="{item}">
                                <tr @click="openEditUnit(item)" style="cursor:pointer; white-space: nowrap">
                                    <td>{{item.imei}}</td>
                                    <td>{{!!item.simcard? `(+47) ${item.simcard.number}`: '-'}}</td>
                                    <td>{{!!item.gate ? item.gate.name : ''}} - {{!!item.gate? (item.gate.direction == 2 ? 'TOVEIS' : (item.gate.direction == 0 ? 'INN' : 'UT')): ''}}</td>
                                    <td>
                                        <div class="d-flex">
                                            <v-btn icon @click.stop="openEditUnit(item)">
                                                <v-icon color="info">mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn icon @click.stop="openDeleteUnit(item)">
                                                <v-icon color="info">mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog v-model="newUnit.show" max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Ny enhet
                </v-card-title>
                <v-card-text>
                    <v-form v-model="newUnit.valid" ref='unitForm'>
                        <v-text-field v-model="newUnit.unit.imei" label="IMEI" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-select v-model="newUnit.unit.simcard" :items="simcards" item-text="number" label="Simkort" return-object :rules="[v => !!v ||'Påkrevd']">
                            <template slot="item" slot-scope="scope">
                                <span>(+47) {{scope.item.number}} - <span class="caption">{{scope.item.ccid}} - {{scope.item.operator}}</span></span>
                            </template>
                            <template slot="selection" slot-scope="scope">
                                <span>(+47) {{scope.item.number}} - <span class="caption">{{scope.item.ccid}} - {{scope.item.operator}}</span></span>
                            </template>
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeNewUnit">Avbryt</v-btn>
                    <v-btn @click="saveNewUnit" :loading="newUnit.loading" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editUnit.show" max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Rediger enhet
                </v-card-title>
                <v-card-text>
                    <v-form v-model="editUnit.valid" ref='editUnitForm'>
                        <v-text-field v-model="editUnit.unit.imei" label="IMEI" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-select v-model="editUnit.unit.simcard" :items="simcards" item-text="number" label="Simkort" return-object :rules="[v => !!v ||'Påkrevd']">
                            <template slot="item" slot-scope="scope">
                                <span>(+47) {{scope.item.number}} - <span class="caption">{{scope.item.ccid}} - {{scope.item.operator}}</span></span>
                            </template>
                            <template slot="selection" slot-scope="scope">
                                <span>(+47) {{scope.item.number}} - <span class="caption">{{scope.item.ccid}} - {{scope.item.operator}}</span></span>
                            </template>
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeEditUnit">Avbryt</v-btn>
                    <v-btn @click="saveEditUnit" :loading="editUnit.loading" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteUnit.show" max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Slett enhet: {{deleteUnit.unit ? deleteUnit.unit.imei : ''}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeDeleteUnit">Avbryt</v-btn>
                    <v-btn @click="confirmDeleteUnit" :loading="deleteUnit.loading" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
// import axios from "axios";
export default {
    data() {
        return {
            gates: [],
            units: [],
            simcards: [],
            unitsLoading: false,
            headers: [
                { text: "IMEI", value: "imei", sortable: true },
                { text: "Simkort", value: "simcard_id", sortable: false },
                { text: "Port", value: "name", sortable: false },
                { text: "Handlinger", sortable: false }
            ],
            newUnit: {
                show: false,
                loading: false,
                valid: false,
                unit: {
                    id: 0,
                    imei: "",
                    simcard_id: 0
                }
            },
            editUnit: {
                show: false,
                loading: false,
                valid: false,
                unit: {
                    id: 0,
                    imei: "",
                    simcard_id: 0
                }
            },
            deleteUnit: {
                show: false,
                loading: false,
                unit: {
                    id: 0,
                    imei: "",
                    simcard_id: 0
                }
            }
        };
    },
    methods: {
        closeDeleteUnit: function() {
            this.deleteUnit.show = false;
            this.deleteUnit.unit = null;
        },
        confirmDeleteUnit: function() {
            this.deleteUnit.loading = true;
            this.axios
                .delete(`/unit/${this.deleteUnit.unit.id}`)
                .then(response => {
                    if (response.data.success) {
                        let index = this.units.findIndex(u => u.id == this.deleteUnit.unit.id);
                        if (index >= 0) {
                            this.units.splice(index, 1);
                        }
                        this.deleteUnit.unit = null;
                        this.$store.commit("snackbar", {
                            text: `Enhet slettet.`,
                            color: "success",
                            show: true
                        });
                        this.deleteUnit.show = false;
                    } else {
                        throw new Error("something went wrong");
                    }
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `Enhet ikke slettet.`,
                        color: "error",
                        show: true
                    });
                })
                .finally(() => {
                    this.deleteUnit.loading = false;
                });
        },
        openDeleteUnit: function(unit) {
            this.deleteUnit.unit = unit;
            this.deleteUnit.show = true;
        },
        closeNewUnit: function() {
            this.newUnit.show = false;
        },
        openNewUnit: function() {
            this.newUnit.unit.imei = "";
            this.newUnit.unit.simcard_id = 0;

            this.newUnit.show = true;
        },
        saveNewUnit: function() {
            if (this.$refs.unitForm.validate()) {
                this.newUnit.loading = true;
                let unit = {};
                if (this.newUnit.unit.id) {
                    unit.id = this.newUnit.unit.id;
                }

                unit.imei = this.newUnit.unit.imei;
                unit.simcard_id = this.newUnit.unit.simcard.id;

                this.axios
                    .put(`/unit`, unit, { params: { includes: "simcard" } })
                    .then(response => {
                        if (response.data.success) {
                            this.units.push(response.data.data);
                            this.$store.commit("snackbar", {
                                text: `Enhet lagret.`,
                                color: "success",
                                show: true
                            });
                            this.newUnit.show = false;
                        } else {
                            this.$store.commit("snackbar", {
                                text: `Enhet ikke lagret.`,
                                color: "error",
                                show: true
                            });
                        }
                    })
                    .catch(err => {
                        this.$store.commit("snackbar", {
                            text: `Error - ${err}.`,
                            color: "error",
                            show: true
                        });
                    })
                    .finally(() => {
                        this.newUnit.unit.id = null;
                        this.newUnit.unit.imei = null;
                        this.newUnit.unit.simcard_id = null;
                        this.newUnit.loader = false;
                    });
            }
        },
        openEditUnit: function(unit) {
            this.editUnit.unit.id = unit.id;
            this.editUnit.unit.imei = unit.imei;
            this.editUnit.unit.simcard_id = unit.simcard_id;
            this.editUnit.unit.simcard = unit.simcard;
            this.editUnit.show = true;
        },
        closeEditUnit: function() {
            this.editUnit.unit.id = 0;
            this.editUnit.unit.imei = "";
            this.editUnit.unit.simcard_id = "";
            this.editUnit.unit.simcard = null;

            this.editUnit.show = false;
        },
        saveEditUnit: function() {
            if (this.$refs.editUnitForm.validate()) {
                this.editUnit.loading = true;

                this.editUnit.unit.simcard_id = this.editUnit.unit.simcard.id;

                this.axios
                    .post(`/unit/${this.editUnit.unit.id}`, this.editUnit.unit)
                    .then(response => {
                        if (response.data.success) {
                            let unit = this.units.find(u => u.id === this.editUnit.unit.id);
                            if (unit) {
                                unit.imei = response.data.data.imei;
                                unit.simcard_id = response.data.data.simcard_id;
                                unit.simcard = this.editUnit.unit.simcard;
                            }
                            this.$store.commit("snackbar", {
                                text: `Enhet redigert.`,
                                color: "success",
                                show: true
                            });
                            this.closeEditUnit();
                        } else {
                            this.$store.commit("snackbar", {
                                text: `Enhet ikke redigert.`,
                                color: "error",
                                show: true
                            });
                        }
                    })
                    .catch(() => {
                        this.$store.commit("snackbar", {
                            text: `Enhet ikke redigert.`,
                            color: "error",
                            show: true
                        });
                    })
                    .finally(() => {
                        this.editUnit.loading = false;
                    });
            }
        }
    },
    mounted() {
        this.unitsLoading = true;
        this.axios
            .get(`/unit?includes=simcard`)
            .then(response => {
                if (response.data.success) {
                    let _units = response.data.data;
                    // units.forEach(u => {
                    //     u.gate = {};
                    //     u.gate.name = "";
                    //     u.gate.direction = 0;
                    // });

                    this.units = _units;
                }
            })
            .then(() => {
                return this.axios.get(`/gate?includes=unit`).then(response => {
                    if (response.data.success) {
                        this.gates = response.data.data;

                        this.units.forEach(u => {
                            this.$set(
                                u,
                                "gate",
                                this.gates.find(g => g.unit.id == u.id)
                            );
                            // u.gate = this.gates.find(g => g.unit.id == u.id);
                        });

                        this.units.sort((a, b) => {
                            if (!a.gate || !b.gate) return 0;

                            if (a.gate.name < b.gate.name) return -1;
                            else if (a.gate.name > b.gate.name) return 1;
                            else return 0;
                        });
                    }
                });
            })
            .then(() => {
                return this.axios.get(`/simcard`).then(response => {
                    this.simcards = response.data.data;
                });
            })
            .finally(() => {
                this.$nextTick().then(() => {
                    this.unitsLoading = false;
                });
            });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="sass" scoped>

</style>
